<template>
    <v-app>
        <v-dialog v-model="showLogin"
                  persistent
                  transition="dialog-bottom-transition">
            <v-container class="white">
                <v-row class="text-center">
                    <v-col>
                        <login
                            v-if="showLogin"
                            @success="$router.go(0)" />
                    </v-col>
                </v-row>
            </v-container>
        </v-dialog>
        <v-container class="py-0">
            <v-row v-if="isDev && !needsLogin" class="text-center">
                <v-col>
                    <span @click="logout">Logout</span>
                </v-col>
            </v-row>
            <v-row class="mt-4">
                <v-col
                    cols="2"
                    class="py-0"
                    align-self="center"
                >
                    <v-btn
                        color="cyan"
                        icon
                        v-if="!needsLogin"
                        @click.stop="drawer = !drawer"
                    >
                        <v-icon large>
                            mdi-menu
                        </v-icon>
                    </v-btn>
                </v-col>
                <v-col
                    class="py-0"
                >
                    <img src="./assets/kruemel.png"/>
                </v-col>
            </v-row>
        </v-container>
        <v-navigation-drawer
            v-model="drawer"
            v-if="!needsLogin"
            absolute
            temporary
        >
            <v-list>
                <v-list-item>
                    <v-list-item-title>
                        <h3>Für alle Krümel</h3>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-for="item in navItems"
                    :key="item.name"
                    :to="item.path"
                    class="indigo--text"
                    link
                >
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.name }}
                            <sup
                                v-if="item.new"
                                class="ml-1 pink--text"
                            >
                                Neu
                            </sup>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-title>
                        <h3>Optionen</h3>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-for="item in optionItems"
                    :key="item.name"
                    :to="item.path"
                    class="indigo--text"
                    link
                >
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.name }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                    v-if="isAdmin">
                    <v-list-item-title>
                        <h3>Für Krümel Admins</h3>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-for="item in adminRoutes"
                    :key="item.name"
                    :to="item.path"
                    class="indigo--text"
                    link
                >
                    <v-list-item-content>
                        <v-list-item-title >{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-container class="py-0">
            <router-view></router-view>
        </v-container>
    </v-app>
</template>

<script>
import {routes} from '@/plugins/router'
import axios from 'axios'
import Login from '@/pages/Login'

export default {
    name: 'App',

    components: {
        Login
    },
    data() {
        return {
            drawer: null,
            showLogin: false
        }
    },
    async created() {
        axios.interceptors.response.use( (response) => {
            // Do something with response data
            return response;
        }, (error) => {
            if (error.response.status === 401) {
                this.showLogin = true
                this.logout()
            }
            return Promise.reject(error)
        })
    },
    computed: {
        adminRoutes() {
            return routes.filter(route => route.navItem && route.admin && this.isAdmin)
        },
        isAdmin() {
            return this.$store.getters.isAdmin
        },
        isDev() {
            return window.location.href.indexOf('localhost') > -1
        },
        needsLogin() {
            return !this.$store.getters.isLoggedIn
        },
        navItems() {
            return routes.filter(route => route.navItem && !route.admin)
        },
        optionItems() {
            return routes.filter(route => route.optionItem && !route.admin)
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('logout')
        }
    }
};
</script>

<style lang="scss">
    @import "./scss/main";
</style>
